import { useFormikContext } from 'formik';
import { ReactElement } from 'react';
import { object, reach } from 'yup';
import {
    NeglectedOrDelinquentInformationFormValues,
} from '../../../types/NeglectedOrDelinquentInformationModel';
import {
    STUDENT_CHARACTERISTIC_FIELDS,
} from '../../../types/NeglectedOrDelinquentStudentCharacteristicsFields';
import { PanelType } from '../../../types/PanelType';
import { createNeglectedOrDelinquentInformationValidationSchema } from '../../../types/Validation/NeglectedOrDelinquentInformationValidationSchema';
import FormTextbox from '../../FormInputs/FormTextbox/FormTextbox';
import Panel from '../../Panel/Panel';

const NeglectedOrDelinquentStudentCharacteristicsPanel = ({
    disabled,
    validationSchema,
}: {
    disabled: boolean;
    validationSchema: ReturnType<
        typeof createNeglectedOrDelinquentInformationValidationSchema
    >;
}): ReactElement => {
    const { errors } = useFormikContext<NeglectedOrDelinquentInformationFormValues>();

    return (
        <Panel panelType={PanelType.INFO} heading="Student Characteristics">
            <p>
                Provide the <strong>number of students</strong> who had any of the
                following characteristics:
            </p>
            <div className="nord-student-characteristics">
                {STUDENT_CHARACTERISTIC_FIELDS.map(({ key, label }) => {
                    const field = `studentCharacteristics.${key}`;
                    const inputSchema = object().shape({
                        [field]: reach(validationSchema, field),
                    });
                    return (
                        <FormTextbox
                            key={key}
                            field={field}
                            displayName={label}
                            disabled={disabled}
                            validationSchema={inputSchema}
                        />
                    );
                })}
            </div>
            {typeof errors.studentCharacteristicsLimit === 'string' && (
                <p className="nord-demographics-error" role="alert">
                    {errors.studentCharacteristicsLimit}
                </p>
            )}
        </Panel>
    );
};

export default NeglectedOrDelinquentStudentCharacteristicsPanel;
